import tmhRequest from '@/config/tmhRequest'


export default {
    searchOtherOrderDetail: function (data) {
        return tmhRequest({
            url: '/order/otherorder/searchotherorderdetail',
            method: 'post',
            params: data,
        })
    },
    searchOtherOrderCount: function (data) {
        return tmhRequest({
            url: '/order/otherorder/searchotherordercount',
            method: 'post',
            data: data,
        })
    },
    searchOtherOrderByPage: function (data) {
        return tmhRequest({
            url: '/order/otherorder/searchotherorderbypage',
            method: 'post',
            data: data,
        })
    },

    closeOtherOrder: function (data) {
        return tmhRequest({
            url: '/order/otherorder/closeotherorder',
            method: 'post',
            params: data,
        })
    },

    startOtherOrder: function (data) {
        return tmhRequest({
            url: '/order/otherorder/startotherorder',
            method: 'post',
            params: data,
        })
    },

    finishOtherOrder: function (data) {
        return tmhRequest({
            url: '/order/otherorder/finishotherorder',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/order/otherorder.js